import * as React from "react";
import { Ago } from "azure-devops-ui/Ago";
import { AgoFormat } from "azure-devops-ui/Utilities/Date";

export default class AgoExample extends React.Component {
    public render(): JSX.Element {
        return <Ago date={new Date()} format={AgoFormat.Compact} />;
    }
}
